/*
 * 报价管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';

export default {
    path: 'help',
    name: 'BusinessHelp',
    component: EmptyRouterAlive,
    meta: {
      title: '用户指南',
    },
    children: [
    {
      path: 'manual',
      name: 'BusinessHelpManual',
      component: EmptyRouter,
      redirect: 'manual/index',
      meta: {
        title: '用户手册',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessHelpManual',
          component: () => import('@/views/center-business/help/manual'),
          meta: {
            title: '用户手册',
            isCache: true,
          },
        },
      ],
    },
  ],
};
